<div class="nlf-page-center">
    <!--<nlf-ui-component-spinner size="3"></nlf-ui-component-spinner>-->
    <!--<i class="text-dark nlf nlf-spin nlf-5x nlf-logo"></i> -->
    <div class="nlf-stack-wide nlf-5x">
        <i class="nlf nlf-stack-2x nlf-spin nlf-propeller text-dark"></i>
        <i class="nlf nlf-logo-plain nlf-stack-2x text-dark"></i>
    </div>
</div>